import { Reducer } from "../../lib/redux";
import { OpenCabQueueActions } from "./actions";
import { OpenCabQueue, OpenCabQueueActionTypes } from "./types";
import { getArrayCopy } from "../../utils/vanilla";

export let defaultOpenCabQueue: OpenCabQueue[] = [];

export let openCabQueue: Reducer<DeepReadonlyArray<OpenCabQueue>, OpenCabQueueActions> = (state = defaultOpenCabQueue, action) => {
    switch (action.type) {
        case OpenCabQueueActionTypes.ENQUEUE_OPENCABQUEUE: {
            if (action.payload) {
                let n = getArrayCopy(state);
                n.push(action.payload);
                return n;
            }
            return state;
        }
        case OpenCabQueueActionTypes.DEQUEUE_OPENCABQUEUE: {
            let n = getArrayCopy(state);
            n.shift();
            return n;
        }
        case OpenCabQueueActionTypes.CLEAR_OPENCABQUEUE: {
            return [];
        }
        default:
            return state;
    }
};
